import {
  Component,
  ViewChild,
  input,
  output
} from '@angular/core';

export interface FileError {
  message: string;
  code: string;
}

@Component({
    selector: 'app-file-control',
    templateUrl: './file-control.component.html',
    styleUrls: ['./file-control.component.scss'],
    standalone: false
})
export class FileControlComponent {
  readonly extensions = input<string[]>([]);

  readonly fileChange = output<File>();

  @ViewChild('uploadInput') uploadInput;

  fileName: string;
  fileError: FileError;

  getInputAccept(): string {
    return this.extensions().map((extention) => `.${extention}`).join(', ');
  }

  onUpload(e) {
    this.uploadInput.nativeElement.click();
  }

  onFileSelect(e) {
    try {
      const file: File = e.target.files[0];
      const fileName = file.name;
      const fileExtension = fileName.substring(
        fileName.lastIndexOf('.') + 1,
        fileName.length,
      );

      if (
        this.extensions().some(
          (extension) =>
            extension?.toLowerCase() === fileExtension?.toLowerCase(),
        )
      ) {
        this.fileName = fileName;

        this.fileChange.emit(file);
        this.onFileError(undefined);
      } else {
        this.fileName = undefined;

        this.fileChange.emit(undefined);
        this.onFileError({
          message: 'Wrong extension',
          code: 'wrongExtension',
        });
      }
    } catch (e) {
      console.warn('The file is not selected: ' + e);
    }
  }

  clear() {
    this.fileName = '';
    this.uploadInput.nativeElement.value = '';
    this.fileChange.emit(undefined);
  }

  onFileError(error: FileError) {
    this.fileError = error;
  }
}
